import styled from 'styled-components';
import { colorVariables } from 'theme/variables';
import { Text } from 'components';

export const RentBuyCardStyled = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
  border: 1px solid ${colorVariables.white_verylightgainsboro};
  padding: 13px 16px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: none;
  transition: 75ms ease-in;

  &:hover {
    border: 1px solid ${colorVariables.blue_navyblue};
    transition: 135ms ease-out;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TopPart = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 9px;
`;

export const BottomPart = styled.div`
  position: relative;
`;

export const StyledText = styled(Text)`
  line-height: 15px;
`;
